<template>
  <div class="font24" id="app">
    <Header />
    <router-view />
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import just from '@/api/justHeight'

  export default {
    name: 'App',
    components: { Header },
    created(){
      just.justZoom();
    },
    mounted() {

    }
  }
</script>

<style>
  #app{
    min-width: 1200px;
    max-width: 1920px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue